module.exports = __webpack_public_path__ + "img/office_tired.4edd2713.png";